import { Typography, useMediaQuery, useTheme } from '@mui/material';

import { LogoLink } from '../styled/Logo.styled';
import logo from '../assets/logo.svg';

const Logo = () => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

  return (
    <LogoLink to="/">
      <img src={logo} alt="Axels logo" />
      {isDesktop && <Typography fontWeight="bold">Axels Chat</Typography>}
    </LogoLink>
  );
};

export default Logo;
